import React from "react";
import moment from "moment";

const NumberToDate = ({ timestamp }) => {
  if (!timestamp) return "";

  // Create a moment object from the timestamp
  const formattedDate = moment(timestamp).format("MMM DD, YYYY hh:mm A");

  return formattedDate;
};

export default NumberToDate;
